import { ApiResponseError, type ApiClient } from "@shell/auth/apiClient";
import {
    recognizeAssetFromPhotoResponseSchema,
    type RecognizeAssetFromPhotoResponse,
} from "../types";
import type { PreprocessedImage } from "./preprocessImageForUpload";

/**
 * POSTs a single image to the recognizer and parses the structured
 * suggestion. The Content-Type header is intentionally NOT set; the
 * browser populates it as `multipart/form-data; boundary=...` when the
 * body is a `FormData`. The auth header is still attached by the
 * shared apiClient wrapper.
 */
export async function recognizeAssetFromPhoto(
    client: ApiClient,
    image: PreprocessedImage,
): Promise<RecognizeAssetFromPhotoResponse> {
    const form = new FormData();
    form.append("image", image.blob, image.fileName);

    const response = await client.fetch("/api/assets/recognize", {
        method: "POST",
        body: form,
    });

    if (!response.ok) {
        const body = await response.text();
        throw new ApiResponseError(response.status, response.statusText, body);
    }

    const raw = (await response.json()) as unknown;
    return recognizeAssetFromPhotoResponseSchema.parse(raw);
}
